// extracted by mini-css-extract-plugin
export var active = "_jz-2";
export var recordingDot = "_jz-1";
export var recordingIndicator = "_jz-0";